export default {
    "created": "{subject} wurde erstellt",
    "updated": "{subject} wurde aktualisiert",
    "deleted": "{subject} wurde gelöscht",

    "createdMail": 'An {recipient} soll die E-Mail mit dem Betreff "{subject}" gesendet werden',
    "updatedMail": "Daten der Mail an {recipient} wurden geändert",
    "updatedMailStatus": "Status der Mail an {recipient} wurde geändert",
    "failedMail": 'Die E-Mail mit dem Betreff "{subject}" an {recipient} konnte nicht gesendet werden',

    "createdStatusNotification": "Statusbenachrichtigung wurde erstellt",
    "updatedStatusNotification": "Statusbenachrichtigung wurde aktualisiert",
    "deletedStatusNotification": "Statusbenachrichtigung wurde gelöscht",

    'createdLocationProject': "Praxisprojekt wurde erstellt",
    'updatedLocationProject': "Praxisprojekt wurde geändert",
    'deletedLocationProject': "Praxisprojekt wurde gelöscht",

    'createdExecutedProgram': "Programmnachweis-Daten im Formular {formProcess} wurden erstellt",
    'updatedExecutedProgram': "Programmnachweis-Daten im Formular {formProcess} wurden geändert",
    'deletedExecutedProgram': "Programmnachweis-Daten im Formular {formProcess} wurden gelöscht",

    "updatedUserSignature": "Signatur wurde erstellt",
    "deletedUserSignature": "Signatur wurde gelöscht",

    "createdUserFilter": "Filterkombination \"{name}\" wurde gespeichert",
    "deletedUserFilter": "Filterkombination \"{name}\" wurde gelöscht",

    "attachedToUser": '"{user}" wurde der Organisation {subject} zugeordnet',
    "attachedToOrganisation": '{subject} wurde der Organisation "{organisation}" zugeordnet',
    "attachedCategory": 'Kategorie "{category}" wurde {subject} zugeordnet',
    "detachedFromUser": '"{user}" wurde aus der Organisation {subject} entfernt',
    "detachedFromOrganisation": '{subject} wurde aus der Organisation "{organisation}" entfernt',
    "detachedCategory": 'Kategorie "{category}" wurde von {subject} entfernt',

    "createdAssociationSettings": 'Verbandseinstellungen für {organisation} wurden erstellt',
    "updatedAssociationSettings": 'Verbandseinstellungen für {organisation} wurden geändert',
    "deletedAssociationSettings": 'Verbandseinstellungen für {organisation} wurden gelöscht',

    "createdEventPerson": 'Personen-Daten wurden hinzugefügt',
    "updatedEventPerson": 'Personen-Daten wurden geändert',
    "deletedEventPerson": 'Personen-Daten wurden gelöscht',

    "createdEvent": 'Maßnahme {event} wurde erstellt',
    "createdProcess": 'Vorgang {process} wurde erstellt',
    "createdFormProcess": 'Formular {formProcess} wurde erstellt',
    "createdEventPersonFormProcess": "Dem Formular {formProcess} wurde eine Person hinzugefügt",
    "createdDocumentFormProcess": 'Dem Formular {formProcess} wurde ein Dokument hinzugefügt',

    "updatedEvent": 'Daten der Maßnahme {event} wurden geändert',
    "updatedProcess": 'Daten des Vorgangs {process} wurden geändert',
    "updatedFormProcess": 'Daten des Formulars {formProcess} wurden geändert',
    "updatedFormProcessStatus": 'Status des Formulars {formProcess} wurde geändert',
    "updatedProcessStatus": 'Status des Vorgangs {process} wurde geändert',

    "deletedEvent": 'Die Maßnahme {event} wurde gelöscht',
    "deletedProcess": 'Der Vorgang {process} wurde gelöscht',
    "deletedFormProcess": 'Das Formular {formProcess} wurde gelöscht',
    "deletedEventPersonFormProcess": 'Vom Formular {formProcess} wurde eine Person entfernt',
    "deletedDocumentFormProcess": 'Vom Formular {formProcess} wurde ein Dokument entfernt',

    "updatedSignature": 'Das Formular {formProcess} wurde vom {signTarget} unterschrieben',
    "removedSignature": 'Im Formular {formProcess} wurde die Unterschrift des {signTarget} entfernt',
    "applicant": 'Antragsteller',
    "management": 'Sachbearbeiter',

    "syncedDocuments": 'Die Maßnahmendokumente der Maßnahme wurden geändert (hinzugefügt: {attached}, entfernt: {detached})',
}